import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PageNotFound.css'; // Import the CSS file for styling

const PageNotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="page-not-found">
      <h1>404</h1>
      <p>Page Not Found</p>
      <button onClick={handleGoHome} className="go-home-button">Go to Homepage</button>
    </div>
  );
};

export default PageNotFound;

